import { render, staticRenderFns } from "./HealthView.vue?vue&type=template&id=6278ae74"
import script from "./HealthView.vue?vue&type=script&lang=js"
export * from "./HealthView.vue?vue&type=script&lang=js"
import style0 from "./HealthView.vue?vue&type=style&index=0&id=6278ae74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports